import { render, staticRenderFns } from "./kanbanBoard.vue?vue&type=template&id=2c19de6b"
import script from "./kanbanBoard.vue?vue&type=script&lang=js"
export * from "./kanbanBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports